import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const GetAllSubjectManager = createAsyncThunk(
  "GetAllSubjectManager/GetAllSubjectManager",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetAllSubjectManager",
        parameters
      );

      const data = response.data.result;
      console.log(data, "app");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AllSubjectManager = createSlice({
  name: "AllSubjectManager",
  initialState: {
    AllSubjectManager: [],
    loadingAllSubjectManager: false,
    errorAllSubjectManager: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllSubjectManager.pending, (state, action) => {
        state.loadingAllSubjectManager = true;
        state.AllSubjectManager = action.payload;
        state.errorAllSubjectManager = null;
      })
      .addCase(GetAllSubjectManager.fulfilled, (state, action) => {
        state.loadingAllSubjectManager = false;
        state.AllSubjectManager = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllSubjectManager.rejected, (state, action) => {
        state.loadingAllSubjectManager = false;
        state.errorAllSubjectManager = action.payload;
      });
  },
});

export default AllSubjectManager.reducer;
